/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Ui_Zone_Active_RecoveryInputs */

const en_ui_zone_active_recovery = /** @type {(inputs: Ui_Zone_Active_RecoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Active Recovery`)
};

const de_ui_zone_active_recovery = /** @type {(inputs: Ui_Zone_Active_RecoveryInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Aktive Erholung`)
};

/**
* | output |
* | --- |
* | "Active Recovery" |
*
* @param {Ui_Zone_Active_RecoveryInputs} inputs
* @param {{ locale?: "en" | "de" }} options
* @returns {LocalizedString}
*/
export const ui_zone_active_recovery = /** @type {((inputs?: Ui_Zone_Active_RecoveryInputs, options?: { locale?: "en" | "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Ui_Zone_Active_RecoveryInputs, { locale?: "en" | "de" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_ui_zone_active_recovery(inputs)
	return de_ui_zone_active_recovery(inputs)
});